import DashboardTemplate from './DashboardTemplate';
import { DollarSign } from 'lucide-react';

const FinanceDashboard = () => {
  return (
    <DashboardTemplate
      functionType="finance"
      title="Finance"
      subtitle="Cash, Runway, EBITDA & Revenue Growth"
      icon={DollarSign}
    />
  );
};

export default FinanceDashboard;
